import { subSeconds } from 'date-fns';
import { PublicClient } from 'viem';

import { getMainTokenContract } from 'modules/api/contracts/getMainTokenContract';
import { convertBlocksToSeconds } from 'modules/api/utils';

export async function getLastRewardDistributionDate(
  client: PublicClient,
): Promise<Date> {
  const contract = getMainTokenContract(client);

  const [rewardBlockRaw, currentBlockRaw] = await Promise.all([
    contract.read._lastRewardDistributionBlock(),
    client.getBlockNumber(),
  ]);

  const rewardBlock = Number(rewardBlockRaw);
  const currentBlock = Number(currentBlockRaw);

  const now = new Date();
  const blockDifference = currentBlock - rewardBlock;

  return subSeconds(now, convertBlocksToSeconds(blockDifference));
}
